import React from 'react';
import styles from './empty.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export const InterviewPracticeHistoryListEmpty = () => {
    return (
        <div className={cx('container')}>
            <div className={cx('empty')}>
                <div className={cx('icon')}/>
                <div className={cx('text')}>
                    <div className={cx('title')}>아직 면접 연습을 진행하지 않았어요.</div>
                    <div className={cx('description')}>면접 연습을 완료하시면 여기서 기록을 확인할 수 있어요.</div>
                </div>
            </div>
        </div>
    );
};
